import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/auth';
import { getDeepLink } from '../utils/deepLink';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';

export function PublicRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  const { isSignedIn, isLoaded } = useClerkAuth();

  console.log('[PublicRoute] render', {
    hasToken: !!token,
    isLoaded,
    isSignedIn,
    pathname: window.location.pathname,
  });

  if (token) {
    console.log('[PublicRoute] Legacy token found, redirecting authenticated user', {
      pathname: window.location.pathname,
    });
    // Redirect authenticated users to their intended destination or default to root
    const deepLink = getDeepLink();
    const destination = deepLink || '/';
    return <Navigate to={destination} replace />;
  }

  console.log('[PublicRoute] No legacy token, checking Clerk auth', { isLoaded, isSignedIn });

  // Check Clerk auth if loaded
  if (isLoaded && isSignedIn) {
    console.log('[PublicRoute] Clerk signed in, redirecting authenticated user', {
      pathname: window.location.pathname,
    });
    const deepLink = getDeepLink();
    const destination = deepLink || '/';
    return <Navigate to={destination} replace />;
  }

  return children;
}

export default PublicRoute;
